import { IonContent, IonHeader, IonPage } from "@ionic/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import FeedItem from "../components/Feed/FeedItem";
import Header from "../components/layout/Header";
import Spinner from "../components/Spinner";
import UserCard from "../components/card/UserCard";
import { searchPosts as searchPostsAction } from "../redux/actions/postActions";
import { Helmet } from "react-helmet-async";

function Search() {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const location = useLocation();

  const postState = useSelector((state) => state.post);
  const { searchPosts, searchUsers } = postState;

  const dispatch = useDispatch();

  useEffect(() => {
    if (location) {
      const qp = new URLSearchParams(location.search);
      const query = qp.get("q");
      if (query) dispatch(searchPostsAction({ query, page }));
    }
  }, [dispatch, location, page]);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        <IonHeader mode="ios">
          <Header />
        </IonHeader>
        <IonContent>
          <div className="explore">
            {searchPosts || searchUsers ? (
              <>
                {/* Users Section */}
                {searchUsers && searchUsers.length > 0 && (
                  <div className="search-section">
                    <h2 className="section-title">
                      {t("search.users") || "Users"}
                    </h2>
                    <div className="users-list">
                      {searchUsers.map((user) => (
                        <UserCard key={user._id} user={user} />
                      ))}
                    </div>
                  </div>
                )}

                {/* Posts Section */}
                {searchPosts && searchPosts.length > 0 ? (
                  <div className="search-section">
                    <h2 className="section-title">
                      {t("search.posts") || "Posts"}
                    </h2>
                    <InfiniteScroll
                      dataLength={searchPosts.length}
                      next={() => setPage(page + 1)}
                      scrollableTarget="main"
                      hasMore={true}
                    >
                      {searchPosts.map((post, idx) => (
                        <FeedItem key={post._id} post={post} index={idx} />
                      ))}
                    </InfiniteScroll>
                  </div>
                ) : searchUsers && searchUsers.length === 0 ? (
                  <div className="display-flex flex-direction-c align-items-c">
                    <div className="view-wrapper ">
                      <h1>{t("search.noResultsTitle")}</h1>
                      <p>{t("search.noResultsMessage")}</p>
                    </div>
                  </div>
                ) : null}
              </>
            ) : (
              <Spinner />
            )}
          </div>
        </IonContent>
      </IonPage>
    </>
  );
}

export default Search;
